import { Box, Group, Stack } from '@mantine/core';
import PlayerCircle from './PlayerCircle';

export default function PlayerList({
  players,
  layout = 'grid',
  size = 200,
  animate = false,
  opacityFn,
  highlightFn,
  isJudgeFn,
  style,
}) {
  if (!players || players.length === 0) return null;

  const circles = players.map((player, index) => (
    <PlayerCircle
      key={player.id}
      player={player}
      index={index}
      size={size}
      opacity={opacityFn ? opacityFn(player, index) : 1}
      animate={animate}
      highlight={highlightFn ? highlightFn(player, index) : false}
      isJudge={isJudgeFn ? isJudgeFn(player, index) : false}
    />
  ));

  if (layout === 'stack') {
    return (
      <Stack gap="md" style={style}>
        {circles}
      </Stack>
    );
  }

  if (layout === 'grid') {
    return (
      <Box style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, ${size}px)`,
        columnGap: `${Math.round(size * 0.2)}px`,
        rowGap: `${Math.round(size * 0.4)}px`,
        justifyContent: 'center',
        ...style,
      }}>
        {circles}
      </Box>
    );
  }

  return (
    <Group spacing="xl" style={style}>
      {circles}
    </Group>
  );
}
